import React from 'react';
import { Phone, MessageCircle, Calendar } from 'lucide-react';
import { SiteData } from '../../types';

interface FloatingCtaBarProps {
  siteData: SiteData;
  onOpenReservation?: () => void;
}

export const FloatingCtaBar: React.FC<FloatingCtaBarProps> = ({ siteData, onOpenReservation }) => {
  if (!siteData) return null;
  const phone = siteData.settings?.phone;
  const whatsapp = siteData.settings?.whatsapp || siteData.settings?.socialLinks?.whatsapp || phone;
  const accentColor = siteData.settings?.accentColor || '#2563EB';

  const cleanPhone = phone ? phone.replace(/[^0-9+]/g, '') : '';
  const cleanWhatsapp = whatsapp ? whatsapp.replace(/[^0-9]/g, '') : '';

  if (!phone && !whatsapp && !onOpenReservation) {
    return null;
  }

  return (
    <div className="fixed bottom-0 inset-x-0 z-40 md:hidden bg-slate-950/90 backdrop-blur-lg border-t border-slate-800 p-2.5 px-4 shadow-2xl flex items-center justify-between gap-2 safe-area-pb">
      {/* WhatsApp Action Button */}
      {cleanWhatsapp && (
        <a
          href={`https://wa.me/${cleanWhatsapp}?text=${encodeURIComponent(
            `Merhaba, ${siteData.name} web siteniz üzerinden ulaşıyorum. Bilgi alabilir miyim?`
          )}`}
          target="_blank"
          rel="noopener noreferrer"
          className="flex-1 py-2.5 px-3 rounded-xl bg-emerald-600 hover:bg-emerald-500 text-white text-xs font-bold flex items-center justify-center gap-1.5 shadow-md active:scale-95 transition"
        >
          <MessageCircle className="w-4 h-4 fill-white" />
          <span>WhatsApp</span>
        </a>
      )}

      {/* Direct Call Button */}
      {cleanPhone && (
        <a
          href={`tel:${cleanPhone}`}
          className="flex-1 py-2.5 px-3 rounded-xl bg-slate-800 hover:bg-slate-700 text-slate-100 text-xs font-bold flex items-center justify-center gap-1.5 border border-slate-700 shadow-md active:scale-95 transition"
        >
          <Phone className="w-3.5 h-3.5 text-blue-400" />
          <span>Hemen Ara</span>
        </a>
      )}

      {/* Reservation CTA */}
      {onOpenReservation && (
        <button
          type="button"
          onClick={onOpenReservation}
          className="flex-1 py-2.5 px-3 rounded-xl text-white text-xs font-extrabold flex items-center justify-center gap-1.5 shadow-md active:scale-95 transition"
          style={{ backgroundColor: accentColor }}
        >
          <Calendar className="w-3.5 h-3.5" />
          <span>{siteData.industry === 'YACHT_RENTAL' ? 'Rezervasyon' : 'Teklif Al'}</span>
        </button>
      )}
    </div>
  );
};
